import type { Viewport } from '@/composables/useCameraControl'

export function createViewportSync(applyViewport: (viewport: Viewport, animate?: boolean) => void) {
  let lastKey: string | null = null

  function keyFor(stepId: string | undefined, viewport: Viewport | null | undefined): string {
    if (!viewport) return `${stepId ?? ''}|none`
    const { cameraX, cameraY, cameraZ, targetX, targetY, targetZ } = viewport
    return `${stepId ?? ''}|${cameraX},${cameraY},${cameraZ},${targetX},${targetY},${targetZ}`
  }

  return {
    sync(stepId: string | undefined, viewport: Viewport | null | undefined) {
      const key = keyFor(stepId, viewport)
      if (key === lastKey) return
      lastKey = key
      if (viewport) applyViewport(viewport)
    },

    markApplied(stepId: string | undefined, viewport: Viewport | null | undefined) {
      lastKey = keyFor(stepId, viewport)
    },
  }
}
